import {_} from 'lodash';
import * as ko from "knockout";
import {nsFa} from "./fn";
import {TBaseOrObservableType} from "../../index";
import i = nsFa.i;
import iconHtml from './icon.html?raw';

export let template = iconHtml;

interface IParams {
    icon: TBaseOrObservableType<string> | (() => string)
    attr?: any
}

export class viewModel {
    constructor(private params: IParams) {
        params.attr = params.attr || {};
    }

    private icon = ko.pureComputed(() => {
        const icon = ko.unwrap(this.params.icon);
        const resolved = _.isFunction(icon) ? (icon as () => string)() : icon;
        return i(String(resolved ?? ''));
    });
}
